import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { DxScrollViewModule } from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { CardsViewComponent } from './cards-view.component';
@NgModule({
  imports: [CommonModule, AbcUiComponentsModule, FlexLayoutModule, MatIconModule, DxScrollViewModule],
  declarations: [CardsViewComponent],
  exports: [CardsViewComponent],
})
export class CardsViewModule {}
